import { serialize } from 'utils/utils';
import { CALL_API, Schemas } from '../middleware/api';

export const TYPES = {
  DAY_OF_MONTH_REQUEST: 'DAY_OF_MONTH_REQUEST',
  DAY_OF_MONTH_SUCCESS: 'DAY_OF_MONTH_SUCCESS',
  DAY_OF_MONTH_FAILURE: 'DAY_OF_MONTH_FAILURE',
  LOAD_CURRENT_MONTH_AVAILABILITY: 'LOAD_CURRENT_MONTH_AVAILABILITY',
};

export const loadCurrentMonthAvailability = dayStamp => ({
  type: TYPES.LOAD_CURRENT_MONTH_AVAILABILITY,
  dayStamp,
});

export const loadDayOfMonthData = (params) => {
  const defaultParams = {
    url: '/holidays/',
    state: '',
    deptDate: 'MANDATORY-TO-BE-OVERRIDEN',
    deptDateFlexibility: -2,
    expose: 'D_DayOfMonth',
  };

  return {
    [CALL_API]: {
      types: [
        TYPES.DAY_OF_MONTH_REQUEST,
        TYPES.DAY_OF_MONTH_SUCCESS,
        TYPES.DAY_OF_MONTH_FAILURE,
      ],
      schema: Schemas.DAY_OF_MONTH,
      endpoint: `/bridge/dayOfMonth.json?${serialize(Object.assign(defaultParams, params))}`,
    },
  };
};



/** WEBPACK FOOTER **
 ** ./src/redux/actions/dayOfMonthActions.js
 **/